import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { InboxPage } from '@/features/inbox/components/InboxPage'

export const Route = createFileRoute('/_auth/')({
  validateSearch: (search: Record<string, unknown>): { conv?: string; channel?: string } => ({
    conv: typeof search.conv === 'string' ? search.conv : undefined,
    channel: typeof search.channel === 'string' ? search.channel : undefined,
  }),
  component: InboxRoute,
})

// eslint-disable-next-line react-refresh/only-export-components
function InboxRoute() {
  const { conv, channel } = Route.useSearch()
  const navigate = useNavigate()

  return (
    <InboxPage
      initialConversationId={conv}
      initialChannelId={channel}
      onChannelChange={(nextChannelId) => {
        void navigate({
          to: '/',
          search: {
            channel: nextChannelId ?? undefined,
          },
          replace: true,
        })
      }}
      onClearConversation={() => {
        void navigate({
          to: '/',
          search: (previous) => ({ ...previous, conv: undefined }),
          replace: true,
        })
      }}
    />
  )
}
